import { useState } from "react";
import { createContext } from "react";
export const ContentContext = createContext();
export const ContentContextProvider = ({ children }) => {
  const [cityData, setCityData] = useState();
  const getContent = (data) => {
    // console.log(data);
    setCityData(data);
    // console.log(data);
    localStorage.setItem("city", JSON.stringify(data));
  };
  // console.log(cityData);
  return (
    <ContentContext.Provider value={{ getContent, cityData }}>
      {children}
    </ContentContext.Provider>
  );
};
